export default __webpack_public_path__ + "static/media/star.35c40e5d.svg";